import React            from 'react';


class Contact extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div style={{ textAlign: 'center' }}>
    <br/><br/><br/>
    Please reach us at <b>admin@flowerdustmusic.com</b>.
</div>
        );}
}
export default Contact;
